import { apiAction } from '../../../shared/store/apiAction';

import * as api from './api';
import { fetchManualAdjustmentReportDataTypes } from './types';

export const fetchManualAdjustmentReportData = apiAction({
  types: fetchManualAdjustmentReportDataTypes,
  apiAction: api.fetchManualAdjustmentReportData,
});
